import React from 'react';
import { TextStatus, ClickableElement } from '@cko/primitives';
import styled, { css } from 'styled-components';
const highlightedStyles = ({ isHighlighted }) => isHighlighted &&
    css `
    color: var(--legacy-action-text-default);
    background: var(--action-bg-decorative-hover);
    > span {
      color: var(--action-bg-secondary);
      background: var(--action-bg-primary);
      border-color: var(--action-bg-primary);
    }
  `;
const ClickableRow = styled(ClickableElement) `
  width: 100%;
  padding: var(--layout-seed) var(--layout-stamp);
  text-align: left;
  border-radius: var(--border-r-sandgrain);
  cursor: pointer;
  color: var(--legacy-action-text-default);
  > span {
    text-transform: none;
  }

  ${highlightedStyles}
`;
export const Suggestion = ({ field, text, isHighlighted }) => {
    return (React.createElement(ClickableRow, { "data-testid": "suggestion", isHighlighted: isHighlighted },
        React.createElement(TextStatus, { interactive: false }, field),
        " ",
        text));
};
